import { Card, CardContent } from "@shared/components/ui/card";

import { STATUS_COLORS, STATUS_OPTIONS } from "@shared/utils/constants";
import { financial, formatPackageStatus } from "@shared/utils/helper";
import { useTranslation } from "react-i18next";

const CardStatusMobile = ({ data }) => {
  const TransferData = formatPackageStatus(data);
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {TransferData.map((item) =>
        item.count || item.value === 0 ? null : (
          <Card
            className={`${
              STATUS_COLORS[item.label]
            } hover:scale-105 transition-transform duration-200 focus-within:ring-2 focus-within:ring-ring`}
            key={item.label}
            tabIndex={0}
            role="region"
            aria-label={`${t(STATUS_OPTIONS[item.label])} status information`}
          >
            <CardContent className="p-4">
              <h2 className="text-lg font-bold mb-3 flex items-center gap-2">
                <div
                  className="w-3 h-3 rounded-full bg-current opacity-70"
                  aria-hidden="true"
                ></div>
                {t(STATUS_OPTIONS[item.label])}
              </h2>
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="text-sm font-medium opacity-90">
                    {t("packages.packages")}:
                  </span>
                  <span className="font-bold">
                    {item.count || item.value} {t("packages.package")}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm font-medium opacity-90">
                    {t("packages.totalAmount")}:
                  </span>
                  <span className="font-bold">
                    {financial(item.totalAmount)} {t("main.currency")}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm font-medium opacity-90">
                    {t("dashboard.totalCost")}:
                  </span>
                  <span className="font-bold">
                    {financial(item.totalCost)} {t("main.currency")}
                  </span>
                </div>
                <div className="flex justify-between items-center pt-2 border-t border-current/20">
                  <span className="text-sm font-medium opacity-90">
                    {t("dashboard.profit")}:
                  </span>
                  <span className="font-bold text-lg">
                    {financial(item.totalProfit)} {t("main.currency")}
                  </span>
                </div>
              </div>
            </CardContent>
          </Card>
        )
      )}
    </div>
  );
};

export default CardStatusMobile;
